module.exports = __webpack_public_path__ + "img/lang-ar.5745270f.png";